module.exports = __webpack_public_path__ + "static/media/T+T_GraceBeck_-24.47e03fdf.JPG";